module.exports = __webpack_public_path__ + "img/KSC08768 (1).fbed3c1d.jpg";